import euLabel from '../../../Assets/technical_info/eu_label.png';
import euLabel_efficiency from '../../../Assets/technical_info/eu_label_tire_efficiency.png';
import euLabel_weather from '../../../Assets/technical_info/eu_label_weather.png';
import euLabel_noise from '../../../Assets/technical_info/eu_label_noise.png';
import noise from '../../../Assets/technical_info/noise.png'

const TechnicalLV1 = () => {
	return (
		<div>
			<p><img alt="" src={euLabel} style={ { width: "min(100%, 300px)", height: "auto", display: "block", margin: "auto"} } /></p>
			
			<p>&nbsp;</p>

			<p><span style={ { fontSize: "24px" } }><strong>Degvielas patēriņa efektivitāte</strong></span></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong> 20% no automašīnas degvielas patēriņa ir saistīti ar riepu rites pretestību. Tā ir pretestība, ko izraisa riepa, saskaroties ar zemi. Viegli ritošai riepai ir mazāka ietekme uz degvielas patēriņu, tāpēc tiek patērēts mazāks enerģijas daudzums berzei un karšanai. Riepas ar zemu degvielas patēriņu būs vai nu A vai B līmenis.</strong></p>

			<p>&nbsp;</p>

			<p><img alt="" src={euLabel_efficiency} style={ { width: "min(100%, 200px)", height: "auto", display: "block", margin: "auto"} } /></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Riepu degvielas efektivitāte tiek noteikta pēc rites pretestības un iedalīta 5 klasēs no A līdz E. A klase norāda uz augstāko degvielas efektivitāti, savukārt E klase - uz zemāko.</p>
			
			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Atšķirības starp ar A kategorijas riepām un ar G kategorijas riepām degvielas ekonomijas ziņā ir <strong>līdz pat 10%.</strong></p>
			
			<p>&nbsp;</p>

			<p><span style={ { fontSize: "24px" } }><strong>Slapjas saķeres rādītājs</strong></span></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong> Slapjas saķeres rādītājs raksturo riepas spēju saglabāt saķeri ar ceļu uz slapjas virsmas. Tas ir viens no svarīgākajiem drošības kritērijiem, jo ietekmē bremzēšanas ceļu un automašīnas vadāmību lietainos apstākļos. Jo labāka riepas saķere, jo ātrāk transportlīdzeklis var apstāties un drošāk saglabāt stabilitāti uz ceļa. Riepas ar vislabāko slapjas saķeres sniegumu parasti atbilst A vai B klasei.</strong></p>

			<p>&nbsp;</p>

			<p><img alt="" src={euLabel_weather} style={ { width: "min(100%, 200px)", height: "auto", display: "block", margin: "auto"} } /></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Slapjas saķeres rādītājs tiek vērtēts 5 klasēs no A līdz E, kur A apzīmē vislabāko saķeri un īsāko bremzēšanas ceļu, bet E - zemāko saķeres līmeni un garāku bremzēšanas ceļu.</p>
			
			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Ārkārtas situācijā daži metri var izšķirt visu. Automašīna ar A vērtējuma riepām <strong>apstājas par 30% ātrāk</strong> nekā automašīna ar F vērtējuma riepām.&nbsp;</p>

			<p>&nbsp;</p>

			<p><span style={ { fontSize: "24px" } }><strong>Ārējais trokšņu līmenis</strong></span></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <strong>Riepas rites troksnis rada daļu no braucošās automašīnas trokšņa. Iegādājoties riepas ar zemu trokšņu līmeņa vērtējumu, varēsiet samazināt braukšanas ietekmi uz apkārtējo vidi. Klusas riepas ir no 65-70db</strong></p>

			<p>&nbsp;</p>

			<p><img alt="" src={noise} style={ { width: "min(100%, 600px)", height: "auto", display: "block", margin: "auto"} } /></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Riepu degvielas efektivitāte tiek noteikta pēc rites pretestības un iedalīta 5 klasēs no A līdz E. A klase norāda uz augstāko degvielas efektivitāti, savukārt E klase - uz zemāko.</p>
			
			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Satiksmes troksnis ir ļoti nozīmīgs apkārtējās vides rādītājs. Tas tiek noteikts, ņemot vērā vairākus kritērijus:</p>
			
			<p>&nbsp;</p>

			<ul>
				<li>Satiksmes intensitāte;</li>
				<li>Braukšanas stils;</li>
				<li>Riepu un ceļa savstarpējā mijiedarbība.</li>
			</ul>

			<p>&nbsp;</p>

			<p><img alt="" src={euLabel_noise} style={ { width: "min(100%, 300px)", height: "auto", display: "block", margin: "auto"} } /></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Ārējais rites troksnis raksturo riepas radīto trokšņa līmeni braukšanas laikā. Tas tiek norādīts decibelos (dB) un iedalīts 3 klasēs: A, B un C, kur A apzīmē klusākās riepas, bet C - skaļākās. Pat nelielas atšķirības decibelos var būt būtiskas, jo trokšņa līmenis tiek mērīts logaritmiskā skalā.</p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Samazinot troksni tikai par dažiem decibeliem, tiek panākta būtiska atšķirība trokšņu līmenī. Tātad <strong>atšķirība par 3 decibeliem dubulto riepas radīto troksni.</strong></p>
		</div>
	);
};

export default TechnicalLV1;
